import { render } from "./PartnerLayout.vue?vue&type=template&id=5d4e4833"
import script from "./PartnerLayout.vue?vue&type=script&lang=js"
export * from "./PartnerLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__